import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const NavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [impactOpen, setImpactOpen] = useState(false);
  const closeTimer = React.useRef(null);
  const impactTimer = React.useRef(null);

  return (
    <nav className="fft-nav">
      <div className="fft-nav-inner">
        <Link to="/" className="fft-logo">
          <span className="fft-logo-name">Food for Thought</span>
          <span className="fft-501c3">501(c)(3) Certified</span>
        </Link>

        <button
          className={`fft-hamburger ${mobileOpen ? 'open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>

        <ul className={`fft-nav-links ${mobileOpen ? 'mobile-open' : ''}`}>

          <li
            className="fft-nav-item has-dropdown"
            onMouseEnter={() => { clearTimeout(closeTimer.current); setAboutOpen(true); }}
            onMouseLeave={() => { closeTimer.current = setTimeout(() => setAboutOpen(false), 200); }}
          >
            <span onClick={() => setAboutOpen(!aboutOpen)}>About Us ▾</span>
            <ul
              className={`fft-dropdown ${aboutOpen ? 'visible' : ''}`}
              onMouseEnter={() => { clearTimeout(closeTimer.current); setAboutOpen(true); }}
              onMouseLeave={() => { closeTimer.current = setTimeout(() => setAboutOpen(false), 200); }}
            >
              <li><Link to="/about/operations">Operations</Link></li>
              <li><Link to="/about/origin">Our Origin</Link></li>
              <li><Link to="/about/leadership">Leadership</Link></li>
            </ul>
          </li>

          <li
  className="fft-nav-item has-dropdown"
  onMouseEnter={() => { clearTimeout(impactTimer.current); setImpactOpen(true); }}
  onMouseLeave={() => { impactTimer.current = setTimeout(() => setImpactOpen(false), 300); }}
>
  <span onClick={() => setImpactOpen(!impactOpen)}>Our Impact ▾</span>
  <ul
    className={`fft-dropdown ${impactOpen ? 'visible' : ''}`}
    onMouseEnter={() => { clearTimeout(impactTimer.current); setImpactOpen(true); }}
    onMouseLeave={() => { impactTimer.current = setTimeout(() => setImpactOpen(false), 300); }}
  >
    <li><Link to="/our-impact/meals" onClick={() => setImpactOpen(false)}>Shared Meals</Link></li>
    <li><Link to="/our-impact/support" onClick={() => setImpactOpen(false)}>Support Teams</Link></li>
    <li><Link to="/our-impact/testimonies" onClick={() => setImpactOpen(false)}>Student Testimonies</Link></li>
  </ul>
</li>

          <li className="fft-nav-item"><Link to="/gallery">Gallery</Link></li>
          <li className="fft-nav-item fft-nav-donate"><Link to="/get-involved">Donate</Link></li>

        </ul>
      </div>
    </nav>
  );
};

export default NavBar;